import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import FrontPage from './pages/FrontPage.jsx';
import RecentRunsPage from './pages/RecentRunsPage.jsx';
import RandomRunPage from './pages/RandomRunPage.jsx';
import RunMapPage from './pages/RunMapPage.jsx';
import YourMapPage from './pages/YourMapPage.jsx';
import StravaLoginPage from './pages/StravaLoginPage.jsx';
import BlogListPage from './pages/BlogListPage.jsx';
import BlogPostPage from './pages/BlogPostPage.jsx';
import RaceListPage from './pages/RaceListPage.jsx';
import RacePage from './pages/RacePage.jsx';
import LiveTrackPage from './pages/LiveTrackPage.jsx';
import RefreshPage from './pages/RefreshPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';

/**
 * Scrolls to a #hash target when navigating to a URL that has one, and to the
 * top otherwise. Reproduces the WordPress site's in-page anchor navigation.
 */
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a tick for the target route to render its content.
      const id = hash.replace('#', '');
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      };
      const t = setTimeout(tryScroll, 100);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default function App() {
  return (
    <>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<FrontPage />} />
        <Route path="/recent-runs" element={<RecentRunsPage />} />
        <Route path="/random-run" element={<RandomRunPage />} />
        <Route path="/run-map" element={<RunMapPage />} />
        <Route path="/your-map" element={<YourMapPage />} />
        <Route path="/unique-map" element={<YourMapPage />} />
        <Route path="/stravalogin" element={<StravaLoginPage />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/races" element={<RaceListPage />} />
        <Route path="/races/:slug" element={<RacePage />} />
        <Route path="/livetrack" element={<LiveTrackPage />} />
        <Route path="/refresh" element={<RefreshPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
